import { History } from 'history'
import { MouseEvent } from 'react'

export const handleClickAsLink = (url: string, push: History['push']) => (e: MouseEvent) => {
  if (e.ctrlKey || e.metaKey) {
    window.open(url, '_blank')
  } else {
    push(url)
  }
}
